<mat-sidenav-container fullscreen>
  <mat-sidenav
    #sidenav
    mode="side"
    class="example-sidenav"
    [ngStyle]="{ 'width.em': sidenavWidth }"
    [opened]="_authService.isOpen$ | async">
    @if (currentPath === 'tutorCounselor') {
      <mindbase-tutor-sidebar></mindbase-tutor-sidebar>
    } @else if (currentPath === 'studentParent') {
    <mindbase-sidebar></mindbase-sidebar>
    }
  </mat-sidenav>
  <div class="example-sidenav-content">
    <div class="top_header">
      <mindbase-search></mindbase-search>
      <div class="top_header_ryt">
        @if (profile) {
          <div
            class="user-pf"
            (click)="handleRouteNavigation()"
            >
            <figure>
              <img [src]="profile.image ? profile.image : assets.placeHolderLogo" alt="profile" />
            </figure>
            <div class="user_pf_rt">
              <span>Good Morning </span>
              @if (profile) {
                <h2>{{profile.name ? profile.name : profile.firstName }}</h2>
              }
            </div>
          </div>
        }
      </div>
    </div>
    <div class="main_wrapper">
      <router-outlet />
    </div>
    <mat-menu #menu="matMenu"> </mat-menu>
  </div>
</mat-sidenav-container>
